export const SITE_NAME = '180 Medical'
const SUFFIX_SEPARATORS = new Set(['|', '-', '–', '—'])

// Index where a trailing "180 Medical" site name begins (one+ whitespace, case-insensitive),
// or -1 when the title doesn't end with the site name.
export function siteNameStart(title: string): number {
  const lower = title.toLowerCase()
  if (!lower.endsWith('medical')) {
    return -1
  }
  const beforeMedical = title.slice(0, lower.length - 'medical'.length)
  const before180 = beforeMedical.trimEnd()
  if (before180.length === beforeMedical.length || !before180.endsWith('180')) {
    return -1
  }
  return before180.length - '180'.length
}

// Head before a separator-joined trailing site name ("Page | 180 Medical" -> "Page"),
// or null when the site name is absent or is prose ("…available at 180 Medical").
export function splitSeparatorSiteSuffix(title: string): string | null {
  const trimmed = title.trimEnd()
  const start = siteNameStart(trimmed)
  if (start === -1) {
    return null
  }
  const beforeSite = trimmed.slice(0, start).trimEnd()
  const lastChar = beforeSite.at(-1)
  return lastChar && SUFFIX_SEPARATORS.has(lastChar) ? beforeSite.slice(0, -1).trim() : null
}
